import { render, staticRenderFns } from "./Scanner.vue?vue&type=template&id=6fa8f578&scoped=true&"
import script from "./Scanner.vue?vue&type=script&lang=ts&"
export * from "./Scanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa8f578",
  null
  
)

export default component.exports